import React, { FC } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { deviceStatus } from 'api/Responses/DeviceResponses';
import { DeviceSearchResponse } from 'api/Responses/SearchResponses';
import { StatusTile } from 'components/StatusTile/StatusTile';
import { useLanguage, useSearch } from 'context/AppContext';
import { TableContainer } from './Table';

interface SearchPartTableProps {
  parts: DeviceSearchResponse[];
}

export const SearchPartTable: FC<SearchPartTableProps> = ({ parts }) => {
  const navigate = useNavigate();
  const [language] = useLanguage();
  const [search, dispatchSearch] = useSearch();

  const handleNavigation = (code: string): void => {
    // Reset the search query and navigate to the draft part page
    dispatchSearch('');
    navigate(`/device/${code}`, { state: { prevSearchQuery: search } });
  };

  return (
    <>
      <h2>{language.DeviceTable.title}</h2>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{language.DevicePage.code}</TableCell>
              <TableCell>{language.DevicePage.description}</TableCell>
              <TableCell>{language.DevicePage.quantity}</TableCell>
              <TableCell>{language.DevicePage.cannulated}</TableCell>
              <TableCell align="center">{language.DevicePage.status}</TableCell>
              <TableCell>{language.DevicePage.user}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parts.map(part => (
              <TableRow key={part.code} onClick={() => handleNavigation(part.code)}>
                <TableCell>{part.code}</TableCell>
                <TableCell>{part.description}</TableCell>
                <TableCell>{part.num_parts}</TableCell>
                <TableCell>
                  {part.cannulated ? language.DevicePage.cannulatedYes : language.DevicePage.cannulatedNo}
                </TableCell>
                <TableCell>
                  {part.status && (
                    <StatusTile status={deviceStatus[part.status]}>{language.DeviceStatus[part.status]}</StatusTile>
                  )}
                </TableCell>
                <TableCell>{part.owner_email ?? '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
